import { required, TextInput } from "react-admin";

import { Grid } from "@mui/material";
import { nameLatinRegexValidator, validateSecondName } from "utils/validations";
import { keepEmptyString } from "./PersonalInfoSection";
const NamesSectionEn = ({ userData, isOther, isDisable, isForeigner }) => {
  return (
    <Grid
      container
      spacing={2}
      paddingBottom={2}
    >
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="userInfo.firstNameEn"
          label="Име"
          defaultValue={userData?.userInfo?.firstNameEn}
          parse={keepEmptyString}
          readOnly={isDisable}
          validate={isForeigner ? [required("Задължително"), nameLatinRegexValidator] : [nameLatinRegexValidator]}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="userInfo.secondNameEn"
          defaultValue={userData?.userInfo?.secondNameEn || null}
          parse={keepEmptyString}
          label="Презиме"
          validate={[validateSecondName, nameLatinRegexValidator]}
          readOnly={isDisable}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="userInfo.lastNameEn"
          label="Фамилия"
          defaultValue={userData?.userInfo?.lastNameEn}
          parse={keepEmptyString}
          readOnly={isDisable}
          validate={isForeigner ? [required("Задължително"), nameLatinRegexValidator] : [nameLatinRegexValidator]}
        />
      </Grid>
    </Grid>
  );
};
export default NamesSectionEn;
